import { Features, FeatureVariants } from 'common/types/search-response-cio-request';

interface ExperimentType {
  id: string;
  cohortId: string;
}

const runningExps = [
  {
    type: 'search',
    enabled: false,
    conTestName: 'use_reranker_service_for_search',
    control: 'search_reranker_v0_rpv_price_top100_tvg',
    variant: 'search_reranker_v0_rpv_price_broken_sizes_top100_tvg',
    vgTestName: 'constructor_search_reranker',
  },
  {
    type: 'browse',
    enabled: true,
    conTestName: 'use_reranker_service_for_browse',
    control: 'browse_reranker_v0_rpv_price_top100_tvg',
    variant: 'browse_reranker_v0_rpv_price_broken_sizes_top100_tvg',
    vgTestName: 'constructor_browse_reranker',
  },
  {
    type: 'promo',
    enabled: true,
    conTestName: 'use_reranker_service_for_browse',
    control: 'browse_reranker_v0_rpv_price_top100_tvg',
    variant: 'browse_reranker_v0_rpv_price_broken_sizes_top100_tvg',
    vgTestName: 'constructor_browse_reranker',
  },
];

export const getExperimentValue = (
  metaFeatures: Features | false,
  metaFeaturesVariant: FeatureVariants | false,
  pageType: string,
) => {
  const experiments: ExperimentType[] = [];

  if (!metaFeatures || !metaFeaturesVariant) return experiments;

  runningExps.forEach((arrayItem) => {
    const { type, enabled, conTestName, variant, vgTestName } = arrayItem;

    if (!enabled || type !== pageType) return;

    const featureValue = metaFeatures[conTestName as keyof typeof metaFeatures];
    const featureVariant = metaFeaturesVariant[conTestName as keyof typeof metaFeaturesVariant];

    const isInVariantPot = featureValue && featureVariant === variant ? 'variant' : 'control';

    experiments.push({ id: vgTestName, cohortId: isInVariantPot });
  });

  return experiments;
};
